// getPageListApi
import Http from '@/Http/Request';
import { useQuery } from 'react-query';
import { CascadingModuleListResponse } from './types';

const getCascadingModule = async () => {
	const { data } = await Http({
		method: 'GET',
		url: 'getCascadingModuleApi',
	});
	return data;
};

const useCascadingModule = () => {
	const { data: response, isLoading, error, refetch } = useQuery<CascadingModuleListResponse, Error>({
		queryKey: ['cascadingModule'],
		queryFn: () => getCascadingModule(),
	});
	const data = response?.data || {} as CascadingModuleListResponse['data']
	const result: CascadingModuleListResponse = {
		data: {
			list: (data.list || []),
		},
		message: response?.message || '',
		status: response?.status || 0
		
	};
	
	return { data: result, isLoading, error, refetch };
};

export default useCascadingModule;
